module.exports = __webpack_public_path__ + "img/ai-rewrite.313a5d5c.png";